namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItemExemptColumns {
        static columnsKey = 'AdvPromo.PsAdvPromoItemExempt';
    }
}
